import React from 'react'
import PropTypes from 'prop-types'
import { Box, Paper, Stack, Typography } from '@mui/material'
import { contextSummary } from '../../service/coaching'

// "What this report used": the immutable, owner-scoped player context snapshot (D18).
export default function ReportContext ({ context, used, digest, compact }) {
  const summary = contextSummary(context, used, digest)
  return <Paper component="section" variant="outlined" aria-label="What this report used" sx={{ p: compact ? 1.25 : 2, mt: compact ? 0 : 2 }}>
    <Typography variant={compact ? 'subtitle2' : 'h6'} component="h2">What this report used</Typography>
    <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>{summary.message}</Typography>
    {summary.status !== 'none' && <Stack spacing={1} sx={{ mt: 1 }}>
      <Typography variant="body2"><strong>Player profile:</strong> {summary.profile || 'No profile details'}{summary.profileRevision ? ` (profile revision ${summary.profileRevision})` : ''}</Typography>
      {summary.game && <Typography variant="body2"><strong>This game:</strong> {summary.game}</Typography>}
      <Typography variant="body2"><strong>Development charter:</strong> {summary.charter || 'None written.'}</Typography>
      <Box>
        <Typography variant="body2"><strong>Active goals</strong></Typography>
        {summary.goals.length
          ? summary.goals.map(goal => <Typography key={goal.ref} variant="body2" sx={{ pl: 1 }}>{goal.ref} · {goal.text}{goal.date ? ` (${goal.date})` : ''}</Typography>)
          : <Typography variant="body2" color="text.secondary" sx={{ pl: 1 }}>None recorded before this run.</Typography>}
      </Box>
      <Box>
        <Typography variant="body2"><strong>Recent history</strong></Typography>
        {summary.history.length
          ? summary.history.map(entry => <Typography key={entry.ref} variant="body2" sx={{ pl: 1 }}>{entry.ref} · {entry.kind}: {entry.text}{entry.date ? ` (${entry.date})` : ''}</Typography>)
          : <Typography variant="body2" color="text.secondary" sx={{ pl: 1 }}>No observations, coach feedback or corrections before this run.</Typography>}
      </Box>
      <Typography variant="body2" color="text.secondary">{summary.leftOut} {summary.knowledge}</Typography>
      <Typography variant="caption" color="text.secondary" sx={{ fontSize: 13 }}>
        Frozen at {summary.cutoff}{summary.digest ? ` · snapshot ${summary.digest}` : ''}. History is context for interpretation, never evidence that something happened in this video.
      </Typography>
    </Stack>}
  </Paper>
}
ReportContext.propTypes = { context: PropTypes.object, used: PropTypes.object, digest: PropTypes.string, compact: PropTypes.bool }
